///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { AuthConsumer } from "../../helpers/authProvider";
import Spinner from "../icons/Spinner";

const Callback = () => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();
      return (
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <Spinner
            className="box-content spinner"
            height="40px"
            width="40px"
            fill="#C9CACC"
          />
        </div>
      );
    }}
  </AuthConsumer>
);

export default Callback;
